import { trackError } from '@atlassian/help-center-common-util/analytics';
import { devLog } from '@atlassian/help-center-common-util/dev-logger';
import { getBrowserBridgeAPI } from '@atlassian/rovo-content-bridge-api/singleton';
import { ROVO_CHAT_CLIENT_ID } from '@atlassian/rovo-content-bridge-api-commands/clients/rovo-chat-client';
import { HELP_CENTER_FORM_REQUEST_CLIENT_ID } from '@atlassian/rovo-content-bridge-api-commands/clients/help-center-form-request-client';
import { NotifySuccessCommand } from '@atlassian/rovo-content-bridge-api-commands/commands/jsm-on-request-submitted-command';

export function notifyRovoRequestCreated(portalUrl: string, action?: string) {
	// Notify Rovo Chat about successful request creation
	try {
		const bridge = getBrowserBridgeAPI();
		bridge.ready(HELP_CENTER_FORM_REQUEST_CLIENT_ID);
		bridge.send(NotifySuccessCommand, {
			message: portalUrl,
			requestUrl: portalUrl,
			action: action || '',
			senderId: HELP_CENTER_FORM_REQUEST_CLIENT_ID,
			receiverId: ROVO_CHAT_CLIENT_ID,
		});
	} catch (e) {
		trackError(
			'Error notifying Rovo Chat of successful request creation',
			{ command: 'notify-success-command' },
			e,
		);
		devLog('Error notifying Rovo Chat of successful request creation', e);
	}
}
